import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { COLORS } from '~/src/styles/tokens/colors';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279, MAX_1439, MAX_1679, MAX_767, MIN_1920 } from '~/src/styles/tokens/break-points';

export const PageContainerLead = styled.main`
    display: flex;
    width: 100%;
    max-width: ${rem(896)};
    min-height: ${rem(896)};
    flex-direction: column;
    padding-left: ${rem(64)};
    padding-right: ${rem(64)};
    margin-left: auto;
    margin-right: auto;
    box-sizing: content-box;
    background-color: ${COLORS.backgroundPrimary};

    ${mediaQuery(
        { minWidth: MIN_1920 },
        css`
            max-width: ${rem(892)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            width: calc(100% - ${rem(80)});
            padding-left: ${rem(40)};
            padding-right: ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1439 },
        css`
            max-width: ${rem(832)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            max-width: ${rem(768)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            width: calc(100% - ${rem(40)});
            padding-left: ${rem(20)};
            padding-right: ${rem(20)};
        `,
    )};
`;
